import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

// Only initialize Sentry in production (not on localhost)
const isProduction = process.env.NODE_ENV === 'production' && !window.location.hostname.includes('localhost')
if (isProduction) {
  Sentry.init({
    dsn: 'https://a69ef943f0d4db815bb0de0bc4d09156@o4510378943315968.ingest.de.sentry.io/4510378992533584',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: process.env.NODE_ENV,
  })
  console.log('Sentry initialized for production environment')
} else {
  console.log('Sentry disabled for local development')
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
